module.exports = __webpack_public_path__ + "img/homemid1.5759464d.png";